import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { dateFormat } from "../../Helper/dateFormat";
import {
  claimListAction,
  claimListResetAction,
} from "../../Action/claimListAction";
import {
  claimStatusListAction,
  claimStatusResetAction,
} from "../../Action/claimStatusAction";

export const useClaimList = (
  invoiceId,
  visible,
  searchDataInvoice,
  isPending
) => {
  const dispatch = useDispatch();

  const [selectedClaim, setSelectedClaim] = useState([]);

  const dataUser = useSelector((state) => state.verifyOtp.data);

  const defaultSearchDataClaim = (invoiceId && {
    ...searchDataInvoice,
    invoiceId: invoiceId,
    pageSize: 20,
    page: 1,
    language: "EN",
    id: dataUser.user_id,
    cardNumb: searchDataInvoice.cardNumb.replace(/-/g, ""),
  }) || {
    clinicId: dataUser.clinicId,
    invoiceId: "",
    // admissionStartDate: moment().format(dateFormat),
    // admissionEndDate: moment().format(dateFormat),
    admissionStartDate: null,
    admissionEndDate: null,
    claimStatus: (isPending && 2) || 1,
    rocNo: "",
    cardNumb: "",
    pageSize: 20,
    page: 1,
    language: "EN",
    key: "",
    id: dataUser.user_id,
  };

  const [searchDataClaim, setSearchDataClaim] = useState(
    defaultSearchDataClaim
  );

  const dataClaim = useSelector((state) => state.claimList);

  //--Handle Error dataClaim & status Claim--//
  useEffect(() => {
    if (dataClaim.finish && dataClaim.error) {
      dataClaim.data.data &&
        Modal.error({
          title: "Error",
          content: dataClaim.data.data.desc,
          onOk() {
            return;
          },
        });
      dispatch(claimListResetAction());
    }
  }, [dataClaim]);

  //--Handle Error dataClaim & status Claim--//

  const dataClaimStatus = useSelector((state) => state.claimStatus);

  //--change claim status--//

  useEffect(() => {
    if (dataClaimStatus.finish && !dataClaimStatus.error) {
      handleSearchClaim("claimStatus", 1);
    }

    if (dataClaim.error) {
      dispatch(claimListResetAction());
    }
  }, [dataClaimStatus]);

  //--change claim status--//

  const onSearchClaim = () => {
    const searchParams = {
      ...searchDataClaim,
      cardNumb: searchDataClaim.cardNumb.replace(/-/g, ""),
      page: 1,
    };

    handleSearchClaim("page", 1);

    dispatch(claimListAction(searchParams));
  };
  const handleSearchClaim = (field, value) => {
    setSearchDataClaim((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  //--pagination --//

  const handlePageClaimChange = (page, pageSize) => {
    handleSearchClaim("page", page);
    dispatch(
      claimListAction({
        ...searchDataClaim,
        cardNumb: searchDataClaim.cardNumb.replace(/-/g, ""),
        page,
      })
    );
  };
  //--pagination--//

  //--Load Data--//

  useEffect(() => {
    if (searchDataClaim.key === "2") {
      dispatch(claimListAction(searchDataClaim));

      dispatch(claimStatusListAction({ id: dataUser.user_id }));
    }

    if (searchDataClaim.key !== "2") {
      setSearchDataClaim(defaultSearchDataClaim);
      dispatch(claimStatusResetAction());
      dispatch(claimListResetAction());
    }
  }, [searchDataClaim.key]);

  //--Load Data--//

  const reloadClaimStatus = () => {
    dispatch(claimStatusListAction({ id: dataUser.user_id }));
  };

  useEffect(() => {
    if (!visible) {
      dispatch(claimListResetAction());
    }
  }, [visible]);

  //--Invoice Detail--//

  useEffect(() => {
    if (invoiceId || isPending) {
      onSearchClaim();
    }
  }, [invoiceId, isPending]);

  //--Invoice Detail--//

  //--visible--//
  useEffect(() => {
    if (visible) {
      setSearchDataClaim(defaultSearchDataClaim);

      dispatch(claimListAction({ ...searchDataClaim }));
      // dispatch(claimStatusListAction({ id: dataUser.user_id }));
    }

    return () => {
      dispatch(claimStatusResetAction());
      setSearchDataClaim(defaultSearchDataClaim);
    };
  }, [visible]);

  //--visible--//

  return {
    setSelectedClaim,
    onSearchClaim,
    handlePageClaimChange,
    handleSearchClaim,
    reloadClaimStatus,
    dataClaim,
    dataClaimStatus,
    selectedClaim,
    searchDataClaim,
  };
};
